import { gql } from "@apollo/client"
import { PartnershipTierSelectorFragment } from "@pallet/features/ApplylistType/components/PartnershipTierSelector/fragment"
import Footer from "page-components/pallet/NavbarLayout/Footer"

export const PARTNERSHIP_TIER_JOB_SLOTS_QUERY = gql`
    query PartnershipTierJobSlotsQuery($itemUuid: String!) {
        partnershipTier(itemUuid: $itemUuid) {
            id
            activeJobPostLimit
        }
    }
`

export const PARTNERSHIP_TIERS_QUERY = gql`
    query PartnershipTiersQuery($pallet: String!) {
        applylist(slug: $pallet) {
            ... on ApplylistType {
                id
                partnership {
                    id
                    canRepurchase
                    recruitingTeam {
                        id
                        uuid
                    }
                }
                partnershipTiers(showDisabled: false) {
                    totalCount
                }
                customHireLink
                logo {
                    source
                }
                primaryColor
                group {
                    id
                }
                ...PalletFooter_applylist
                ...PartnershipTierSelectorFragment
            }
        }
    }
    ${Footer.fragment}
    ${PartnershipTierSelectorFragment}
`
